export const LV_ShipmentStateTR={
ShStID:{en:'ShStID',cs:'ShStID',dataType:'number',format:'#0',required:true},
ShStName:{en:'ShStName',cs:'ShStName',dataType:'string',required:true,maxLength:255},
ShStNameCaption:{en:'Status',cs:'Stav',dataType:'string',required:true,maxLength:255}
}